import { render, staticRenderFns } from "./NextStepsAndTechnical.vue?vue&type=template&id=1df32e4a&"
import script from "./NextStepsAndTechnical.vue?vue&type=script&lang=js&"
export * from "./NextStepsAndTechnical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports